import { useState } from 'react';
import UploadTramitesSAT from '../components/UploadTramitesSAT';
import { Alert, Snackbar } from '@mui/material';
const UploadTramitePage = () => {
  const [message, setMessage] = useState({
    open: false,
    message: null,
    severity: 'success',
  });
  return (
    <>
      <UploadTramitesSAT message={message} setMessage={setMessage} />

      {/* Snackbar para mensajes */}
      <Snackbar
        open={message.open}
        autoHideDuration={6000}
        onClose={() => setMessage({ ...message, open: false })}
      >
        <Alert
          severity={message.severity}
          onClose={() => setMessage({ ...message, open: false })}
          style={{ overflowWrap: 'anywhere' }}
        >
          {message.message}
        </Alert>
      </Snackbar>
    </>
  );
};
export default UploadTramitePage;
